(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var canvas = document.getElementById('bourgeois-particles');
  if (!canvas) return;

  var ctx = canvas.getContext('2d');
  var W = 0, H = 0;
  var MAX = 60;
  var particles = [];

  function rand(a, b) { return a + Math.random() * (b - a); }

  function spawn(scattered) {
    return {
      x: rand(0, W),
      y: scattered ? rand(0, H) : H + rand(5, 15),
      radius: rand(0.5, 1.5),
      vy: -rand(0.3, 0.8),
      vx: rand(-0.25, 0.25),
      maxAlpha: rand(0.3, 0.6)
    };
  }

  function init() {
    particles = [];
    for (var i = 0; i < MAX; i++) particles.push(spawn(true));
  }

  function resize() {
    W = canvas.width = window.innerWidth;
    H = canvas.height = window.innerHeight;
    init();
  }

  function tick() {
    ctx.clearRect(0, 0, W, H);

    for (var i = 0; i < particles.length; i++) {
      var p = particles[i];
      p.x += p.vx;
      p.y += p.vy;

      if (p.y < -10 || p.x < -20 || p.x > W + 20) {
        particles[i] = spawn(false);
        continue;
      }

      var progress = Math.max(0, Math.min(1, 1 - p.y / H));
      var alpha;
      if (progress < 0.15) {
        alpha = p.maxAlpha * (progress / 0.15);
      } else if (progress > 0.85) {
        alpha = p.maxAlpha * ((1 - progress) / 0.15);
      } else {
        alpha = p.maxAlpha;
      }

      ctx.beginPath();
      ctx.arc(p.x, p.y, p.radius, 0, 6.2832);
      ctx.fillStyle = 'rgba(255,255,255,' + alpha.toFixed(3) + ')';
      ctx.fill();
    }

    requestAnimationFrame(tick);
  }

  window.addEventListener('resize', resize);
  resize();
  tick();
})();
